var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtheIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#FEFCFC",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.76183594 -0.00515625 1.52367187 -0.0103125 2.30859375 -0.015625 C5.99449515 0.41876199 8.00288345 1.55047931 10.3125 4.4375 C11.91104267 8.03422101 12.04221981 10.34371011 11.5625 14.25 C8.48557692 19.78846154 8.48557692 19.78846154 5.5625 21.25 C0.59575767 21.86534861 -3.20079005 22.03240834 -7.5 19.3125 C-10.02889304 15.31521745 -10.74528665 11.96084572 -10.4375 7.25 C-8.28294302 2.1867911 -5.53051491 -0.03730533 0 0 Z ",
    fill: "#DB3E3E",
    transform: "translate(15.4375,4.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.875 1.0625 1.875 1.0625 3 3 C3.63316583 8.90954774 3.63316583 8.90954774 1.875 11.9375 C-0.88980433 13.50422245 -2.88188517 13.38976435 -6 13 C-7.875 11.9375 -7.875 11.9375 -9 10 C-9.63316583 4.09045226 -9.63316583 4.09045226 -7.875 1.0625 C-5.11019567 -0.50422245 -3.11811483 -0.38976435 0 0 Z ",
    fill: "#FDF4F4",
    transform: "translate(19,9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtheIcon);
export default __webpack_public_path__ + "static/media/othe-icon.9621eb4f709649fe832246f224f7f793.svg";
export { ForwardRef as ReactComponent };